import request from '@/utils/request';
import Vue from 'vue';
//列表 
export function orderMgrQuery(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/query`,
    data: params
  });
}
// 
export function getByOrderBid(params) {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/getByOrderBid/${params}`
  });
}

export function downloadInformation(params) {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/downloadInformation/` + params,
    responseType: 'arraybuffer',
    headers: {
      type: 'file'
    }
  });
}

export function updateOrderState(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/updateOrderState/${params}`
  });
}

export function getAllOrderState() {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/getAllOrderState`
  });
}

export function repulse(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/repulse`,
    data: params
  });
}

export function getFinanceData(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/getFinanceData`,
    data: params
  });
}

export function downloadFinanceData(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/downloadFinanceData`,
    data: params,
    responseType: 'arraybuffer',
    headers: {
      type: 'file'
    }
  });
}